module.exports = __webpack_public_path__ + "static/media/dollar.45556bb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/dollar.svg
// module id = 1011
// module chunks = 0